import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./style.css";
import "../../../../../../index.css";
class MajorQuerySearch extends Component {
  render() {
    const { visible } = this.props;
    return (
      <div
        className={
          visible === true
            ? "majorQuerySearch_box"
            : "majorQuerySearch_box display_none"
        }
      >
        <div className="majorQuerySearch_box_div">
          <div className="majorQuerySearch_box_div_img fl">
            <img
              alt=""
              src={require("../../../../../../images/search/search_2.png")}
            ></img>
          </div>
          <div className="majorQuerySearch_box_div_input fl">
            <input
              onClick={this.handleVisibleSearch}
              placeholder="请输入想学习的专业"
              value=""
              readOnly
            ></input>
          </div>
        </div>
      </div>
    );
  }
  handleVisibleSearch = () => {
    //this.props.handleVisibleSearch();
    this.props.history.push("/majorquery/search?from=/majorquery");
  };
}

export default withRouter(MajorQuerySearch);



// WEBPACK FOOTER //
// ./src/containers/PowerfulQuery/components/MajorQuery/components/MajorQuerySearch/index.js